import React__default from 'react';
import MessageBubble from '../MessageBubble/index.js';

var MessageAudioPart = function MessageAudioPart(_a) {
  var part = _a.part;

  var getMessageFromPart = function getMessageFromPart(part) {
    return part.message;
  };

  var getVideoMessagePartUrl = function getVideoMessagePartUrl(messagePart) {
    var body = messagePart.body;
    return body.mediaUrl;
  };

  var message = getMessageFromPart(part);
  var sourceUrl = getVideoMessagePartUrl(part);
  return React__default.createElement(MessageBubble, {
    message: message
  }, React__default.createElement("audio", {
    src: sourceUrl,
    controls: true
  }, "Sorry, your browser doesn't support embedded audios, but don't worry, you can", ' ', React__default.createElement("a", {
    href: sourceUrl,
    target: "_blank"
  }, "download it"), ' ', "and listen to it with your favorite audio player!"));
};

export default MessageAudioPart;
//# sourceMappingURL=index.js.map
